import React, { useMemo } from 'react'
import { strings } from '@constants'
import { Button, TableColumns } from '@base'
import { HeaderWapper, Heading, TableContainer, TableWapper, Wapper } from '../style'
import { useNavigate } from 'react-router'
import { paths } from '@routes'

const NewEnquiryQuotes = ({ enquiries }) => {
	const navigate = useNavigate()

	const columns = useMemo(
		() => [
			TableColumns.idColumn({}),
			TableColumns.dateColumn({ key: 'date', label: strings('enquiry', 'date'), align: 'left', mobile: false }),
			{
				label: strings('supplier'),
				key: (item) => (item?.supplier_name ? item?.supplier_name : '-'),
				mobile: true,
			},
			{
				label: strings('category'),
				key: (item) => (item?.category ? item?.category : '-'),
				mobile: true,
			},

			{
				label: strings('qty'),
				key: (item) => (item?.quantity ? `${item?.quantity} MT` : '-'),
				mobile: true,
			},
			TableColumns.actionsColumn({
				align: 'center',
				renderer: (row) => {
					return (
						<Button small type='secondary' onClick={(e) => buttonClickHandler(e, row)}>
							Submit Quote
						</Button>
					)
				},
				mobile: false,
			}),
		],
		[]
	)

	const buttonClickHandler = (e, row) => {
		e.stopPropagation()
		navigate(paths.admin_manage_enquiry_manage(row.enquiry_id))
	}

	return (
		<Wapper FlexColumn>
			<HeaderWapper>
				<Heading>New Enquiry Assigned for Quotes</Heading>
			</HeaderWapper>
			<TableContainer>
				<TableWapper
					fullHeight={true}
					data={enquiries || []}
					columns={columns}
					rowsToDisplay={10}
					totalItemCount={50}
					page={0}
					onRowClick={() => {}}
					rowClickable={false}
					hideFooter
				/>
			</TableContainer>
		</Wapper>
	)
}

export default NewEnquiryQuotes
